import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { OauthService } from './data-access/services/oauth.service';
import { AlertComponent } from '../../shared/ui/components/alert/alert.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, AlertComponent],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  username: string = '';
  password: string = '';
  errorMessage: string = '';
  isLoading: boolean = false;

  constructor(private router: Router, private oauthService: OauthService) {}

  onSubmit() {
    this.isLoading = true;
    
    if (!this.username || !this.password) {
      this.errorMessage = 'Por favor ingresa usuario y contraseña';
      this.isLoading = false;
      return;
    }

    this.errorMessage = '';

    this.oauthService.login(this.username, this.password).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.success) {
          this.router.navigate(['/users']);
        } else {
          this.errorMessage = response.error || 'Credenciales inválidas';
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.errorMessage = 'Error al conectar con el servidor';
        console.error('Login error:', error);
      }
    });
  }
}
